var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#0A0A0A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_808_2625)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.59994 8.5H22.3999C23.2836 8.5 23.9999 9.33947 23.9999 10.375V21.625C23.9999 22.6605 23.2836 23.5 22.3999 23.5H9.59994C8.71628 23.5 7.99994 22.6605 7.99994 21.625V10.375C7.99994 9.33947 8.71628 8.5 9.59994 8.5ZM21.2812 14.5H10.7187C10.0456 14.5 9.49994 15.0876 9.49994 15.8125V16.25H13.2259C13.4414 16.25 13.648 16.3422 13.8004 16.5063L14.6129 17.3813C14.9808 17.7774 15.4797 18 15.9999 18C16.5202 18 17.0191 17.7774 17.387 17.3813L18.1995 16.5063C18.3518 16.3422 18.5585 16.25 18.774 16.25H22.4999V15.8125C22.4999 15.0876 21.9543 14.5 21.2812 14.5ZM9.49994 12.5C9.49994 11.6716 10.0456 11 10.7187 11H21.2812C21.9543 11 22.4999 11.6716 22.4999 12.5V13H9.49994V12.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_808_2625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet_Icon.38f9c03d2e7b0de43efc47719e2025a8.svg";
export { ForwardRef as ReactComponent };